import { formattedDate, twoDaysBeforeFormatted } from "@/helpers/TimeFormat";
import React, { FC } from "react";

/**
 * PaymentPreview (receives data from parent component)
 * Props:
 * - payments: [{ label, date, amount }]
 * - bartendingPackageTotal: number
 * - estimatedAlcoholPayment: number
 */

interface Props {
    payments: {
        fullPayment: boolean;
        deposit: number | string | "";
        platformFee: number | string | "";
        totalDeposit: number | string | "";
        firstPaymentDueDate: Date | null;
        secondPayment?: number | string | "";
        secondPaymentDueDate: Date | string | number | null;
    };
    bartendingPackageTotal: number;
    estimatedAlcoholPayment: number;
    estimatedTotalCost: number;
    eventDate: Date | null;

}
const fmt = (n: number) =>
    n?.toLocaleString(undefined, {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
    });
const PaymentPreview: FC<Props> = ({
    payments,
    bartendingPackageTotal,
    estimatedAlcoholPayment,
    estimatedTotalCost,
    eventDate
}) => {

    return (
        <div className="w-full bg-white">
            <h1 className="font-[600] text-[16px] text-[#282828]">Quote</h1>
            <h2 className="mt-5 mb-3 font-[600] text-[16px] text-[#282828]">
                Payment Summary
            </h2>
            <div className="overflow-hidden">
                <div className="border-b border-gray-200">
                    {payments.fullPayment && <PaymentPreviewRow
                        label="Full Payment"
                        date={formattedDate(payments.firstPaymentDueDate)}
                        amount={payments.totalDeposit}
                    />
                    }
                    {!payments.fullPayment && <PaymentPreviewRow
                        label="Service Deposit"
                        date={formattedDate(payments.firstPaymentDueDate)}
                        amount={payments.totalDeposit}
                    />
                    }
                    {!payments.fullPayment && <PaymentPreviewRow
                        label="Remaining Service Balance"
                        date={formattedDate(payments.secondPaymentDueDate as any) || twoDaysBeforeFormatted(eventDate)}
                        amount={payments.secondPayment}
                    />
                    }
                    <PaymentPreviewRow
                        label="Alcohol Total"
                        date=""
                        amount={estimatedAlcoholPayment}
                    />
                </div>
            </div>
            <div className="mt-6">
                <div className="ml-auto w-full max-w-xs text-sm">
                    <Row
                        label="Service Total"
                        value={fmt(bartendingPackageTotal)}
                    />
                    <Row
                        label="Alcohol Total"
                        value={fmt(estimatedAlcoholPayment)}
                    />
                    <div className="mt-3 pt-3 flex items-center justify-between border-gray-200 border-t">
                        <span className="text-[10px] text-gray-600">
                            Event Total
                        </span>
                        <span className="text-lg font-semibold text-gray-900">
                            {fmt(estimatedTotalCost)}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PaymentPreview;

function PaymentPreviewRow({ label, date, amount }: any) {
    return (
        <div
            className={`grid grid-cols-3 font-[500] text-xs text-[#202224] border-gray-200 border-t`}>
            <div className="px-4 py-4 text-left text-[10px]">{label}</div>
            <div className="px-4 py-4 text-gray-600 text-center text-[10px]">
                {date}
            </div>
            <div className="px-4 py-4 text-gray-900 text-right text-[10px]">
                {fmt(amount)}
            </div>
        </div>
    )
}

function Row({ label, value }: { label: string; value: string }) {
    return (
        <div className="flex items-center justify-between">
            <span className="text-gray-600 text-[10px]">{label}</span>
            <span className="text-gray-800 text-[10px]">{value}</span>
        </div>
    );
}
